export function interceptStorageEvents() {
    const originalSetItem = localStorage.setItem;
  
    localStorage.setItem = function (key, value) {
      const event = new Event('jwt-updated');
      originalSetItem.apply(this, arguments);
  
      if (key === 'jwt') {
        window.dispatchEvent(event);
      }
    };
  }